import React from 'react';
import { EVENT_TYPES } from '@/shared/constants/event-types.v4';
import { PerformanceBody } from './bodies/PerformanceBody';
import { NutritionBody } from './bodies/NutritionBody';
import { SupplementBody } from './bodies/SupplementBody';
import { RecoveryBody } from './bodies/RecoveryBody';
import { TaskBody } from './bodies/TaskBody';

interface EventComposerBodySwitcherProps {
    event: any;
    templateDetails: any;
    updatePerformanceLog: (updates: any) => void;
    updatePreviewData: (updates: any) => void;
    updatePayload: (updates: any) => void;
    onStartTracker: () => void;
}

/**
 * EventComposerBodySwitcher: Pure renderer that selects the correct UI body
 * based on the Event Type. 
 */
export const EventComposerBodySwitcher: React.FC<EventComposerBodySwitcherProps> = ({
    event,
    templateDetails,
    updatePerformanceLog,
    updatePreviewData,
    updatePayload,
    onStartTracker
}) => {
    switch (event.type) {
        case EVENT_TYPES.PERFORMANCE:
        case EVENT_TYPES.MOBILITY:
            return (
                <PerformanceBody 
                    data={event} 
                    template={templateDetails} 
                    updatePerformanceLog={updatePerformanceLog}
                    onStartTracker={onStartTracker}
                />
            );
        case EVENT_TYPES.RECOVERY:
            return <RecoveryBody data={event} updatePayload={updatePayload} />;
        case EVENT_TYPES.NUTRITION:
            return <NutritionBody data={event} updatePayload={updatePayload} updatePreviewData={updatePreviewData} />;
        case EVENT_TYPES.SUPPLEMENTATION:
            return <SupplementBody data={event} updatePayload={updatePayload} />;
        case EVENT_TYPES.TASK:
            return <TaskBody data={event} updatePayload={updatePayload} />;
        default:
            return null;
    }
};
